import { Button, Stack } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import CounterBadge from "../counter-badge/CounterBadge";
import { ArrowRotateRight } from "iconsax-react";

const padding = {
  sm: { xs: "3px", md: "6px" },
  md: { xs: "6px", md: "10px" },
};

interface IReloadButton {
  size?: "sm" | "md";
  reloadAction: () => void;
  reloadCounter?: number;
  forceRelode?:boolean
}

export default function ReloadButton({
  size = "md",
  reloadAction,
  reloadCounter,
  forceRelode
}: Readonly<IReloadButton>) {
  const [count, setCount] = useState<number | null>(reloadCounter ?? null);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setCount(reloadCounter ?? null);
  }, [reloadCounter]);

  useEffect(() => {
    if (!reloadCounter) return;

    timerRef.current = setInterval(() => {
      setCount((prev) => {
        if (prev === null) return null;
        if (prev <= 1) {
          reloadAction();
          return reloadCounter;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [reloadCounter, reloadAction]);

  //Reset timer when forceRelode = true
  useEffect(() => {
    if (!forceRelode) return;

    if (timerRef.current) clearInterval(timerRef.current);

    setCount(reloadCounter ?? null);

    if (reloadCounter) {
      timerRef.current = setInterval(() => {
        setCount((prev) => {
          if (prev === null) return null;
          if (prev <= 1) {
            reloadAction();
            return reloadCounter;
          }
          return prev - 1;
        });
      }, 1000);
    }
  }, [forceRelode]);

  const handleReloadAction = () => {
    reloadAction();
    setCount(reloadCounter ?? null);
  };

  return (
    <Stack
      onClick={handleReloadAction}
      component={Button}
      sx={{
        position: "relative",
        display: { md: "flex" },
        paddingY: padding[size],
        width: { md: "fit-content" },
        border: ".8px solid #00000023",
        borderRadius: "5px",
        paddingX: padding[size],
        backgroundColor: "transparent",
        cursor: "pointer",
        height: "fit-content",
        minWidth: { xs: "0", md: "fit-content" },
      }}
    >
      {reloadCounter && count !== null && (
        <Stack
          sx={{
            position: "absolute",
            top: "-6px",
            left: "-6px",
            width: "18px",
            height: "18px",
          }}
        >
          <CounterBadge
            count={count}
            color={(theme: any) => theme.palette.others.activeBg as any}
            bgcolor={(theme: any) => theme.palette.others.active}
          />
        </Stack>
      )}
      <ArrowRotateRight size="18" />
    </Stack>
  );
}
